import { FileQuestion } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { EmptyState } from "@/components/common/EmptyState";
import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <EmptyState
      className="py-24"
      icon={FileQuestion}
      title={t("notFound.title")}
      description={t("notFound.description")}
      action={
        <Button asChild>
          <Link to="/">{t("notFound.back")}</Link>
        </Button>
      }
    />
  );
}
